import { endpoints, getDatabaseData } from './index';

const getResponses = async () => {
  const response = await getDatabaseData(endpoints.RESULT_RESPONSE).then(
    data => data
  );

  return response;
};

export default { getResponses };



// WEBPACK FOOTER //
// ./src/api/responses.js